module.exports = __webpack_public_path__ + "img/abeja_logo.45bbab4a.png";